import React from "react";

export default function Navbar() {
  return (
    // Navigation
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top"  id="mainNav">
      <div className="container" >
        <a className="navbar-brand js-scroll-trigger" href="http://www.meandeepclean.com/#page-top">
          Mean Deep Clean
        </a>
        <button
          className="navbar-toggler navbar-toggler-right"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          Menu
          <i className="fas fa-bars" />
        </button>

        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav text-uppercase ml-auto">
            <li className="nav-item">
              <a className="nav-link js-scroll-trigger"  href="http://www.meandeepclean.com/#services">
                Services
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link js-scroll-trigger" href="http://www.meandeepclean.com/#portfolio">
                Portfolio
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link js-scroll-trigger" href="https://app.zenmaid.com/book/mean-deep-clean" >
                Book Now
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link js-scroll-trigger" href="http://www.meandeepclean.com/#about">
                Testimonials
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link js-scroll-trigger" href="http://www.meandeepclean.com/#contact">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

  );
}
